import React from 'react';
import { CONFIG } from '../../../../../config/mainConfig';

interface ActionButtonsProps {
  disabledGenerateNewCharacter: boolean;
  disabledContinue: boolean;
  limit?: number | null;
  maxLimit?: number | null;
  handleChangingRequest: () => void;
  startStepFour: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
                                                       disabledGenerateNewCharacter,
                                                       disabledContinue,
                                                       handleChangingRequest,
                                                       startStepFour,
                                                       limit,
                                                       maxLimit
                                                     }) => {
  return (
    <div
      className="w-[18rem] md:w-[25rem] flex justify-center md:justify-end gap-2 mx-0 md:mx-auto flex-wrap md:flex-nowrap">
      <button
        title={`This Request Will Use ${CONFIG.BILLING.DEDUCT_CREDITS_PER_IMAGE} Image Credits`}
        disabled={disabledGenerateNewCharacter}
        onClick={async () => handleChangingRequest()}
        className={`submit-button ${disabledGenerateNewCharacter && 'opacity-50'
        }  bg-storyblueSecondLightText text-white font-bold rounded-2xl px-4 py-2 text-sm flex justify-center items-center`}>
        Regenerate Character {maxLimit ? <span className="pl-2">{limit}/{maxLimit}</span> : ''}
      </button>
      <button
        id="step-next-button"
        onClick={startStepFour}
        disabled={disabledContinue}
        className={`submit-button bg-storyblue ${disabledContinue ? 'opacity-50' : ''} text-white font-bold text-sm rounded-2xl px-4 py-2 whitespace-nowrap`}>
        Continue
      </button>
    </div>
  );
};

export default ActionButtons;
